<template>
    <div class="home">
        <div class="nav">
            <ul id="main" class="swiper-pagination">                 
                
            </ul>
            
        </div>           
        <swiper
            :slides-per-view="1"
            :space-between="0"
            :loop="false"
            :pagination="pagination"
            :initialSlide="getSwiperIndex"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
        >   
            <swiper-slide v-slot="{ isActive }">
                
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                    <post-recent/>
                    <Footer/>
                </div>
             
            </swiper-slide>
        
            <swiper-slide v-slot="{ isActive} ">
                <!--멘토리 -->
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                    <mentory :active="isActive"/>
                    <Footer/>
                </div>        
            </swiper-slide>
    
            <swiper-slide v-slot="{ isActive} ">
                <!--게임등급 -->
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                  <game-grade :active="isActive"/>
                  <Footer/>
                </div>
            </swiper-slide>

            <swiper-slide v-slot="{ isActive} ">
                <!--게임조아 -->
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                  <game-joa :active="isActive"/>
                  <Footer/>
                </div>
            </swiper-slide>

             <swiper-slide v-slot="{ isActive} ">
                <!--스팀위키 -->
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                  <steam-weaky :active="isActive"/>
                  <Footer/>
                </div>
            </swiper-slide>
            <swiper-slide v-slot="{ isActive} ">
                <!--커뮤니티 -->
                <div class="swiper_wrap" :class="{current:isActive}" v-on:scroll.passive="handleScroll">
                  <community :active="isActive"/>
                  <Footer/>
                </div>
            </swiper-slide>
    
        </swiper>
      
        <div class="scrollToTop" @click="scrollToTop()">
            <font-awesome-icon :icon="['fas', 'arrow-up']" />
        </div>       
    </div>
</template>
<script>
  // import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
  // Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

import PostRecent from '@/mobile/pages/home/PostRecent'
import Mentory from '@/mobile/pages/home/Mentory'
import GameGrade from '@/mobile/pages/home/GameGrade'
import GameJoa from '@/mobile/pages/home/GameJoa'
import SteamWeaky from '@/mobile/pages/home/SteamWeaky'
import Community from '@/mobile/pages/home/Community'
import Footer from '@/mobile/components/ui/Footer'
const menu =['','멘토리','게임등급','게임조아','스팀위키','커뮤니티']
export default {
    name:'mobile_home',   
    data(){
        return{  
               
            pagination:{
                "el":'.swiper-pagination',
                "clickable": true,
                "renderBullet": function (index, className) 
                {  
                    if(index < 5)
                    {
                        return '<li class="' + className + '"><span>' + (menu[index]) + '</span></li>';  
                    } else{
                        return '<li class="' + className + '"><span>' + (menu[index]) + '</span></li><div id="marker"></div>'; 
                    }                   
                                    
                }           
            },            
        }
    }, 
    components: {        
        Swiper,
        SwiperSlide,
        PostRecent,
        Mentory,
        GameGrade,
        GameJoa,
        SteamWeaky,
        Community,
        Footer
    }, 
    computed:{
        getSwiperIndex()
        {
           
            return this.$store.state.menu.swiperIndexHome;           
                    
        }
    },
    methods:{
        test(){
            alert();
        },
        handleScroll(event) {            
            // console.log('총높이',event.target.scrollHeight);
            // console.log(window.screen.height);
            // console.log('현재스크롤',event.target.scrollTop);            
            let currentHeight = window.screen.height;
            let curretnScrollTop = event.target.scrollTop
            if(currentHeight - curretnScrollTop < 0)
            {
                document.querySelector('.scrollToTop').classList.add('showscrollToTop');
            }else{
                document.querySelector('.scrollToTop').classList.remove('showscrollToTop');   
            }
        },
        scrollToTop()
        {
            document.querySelector('.current').scrollTo(0,0)
        },
        onSwiper(swiper) {
            console.log(swiper);
        },
        onSlideChange(swiper) {
            // console.log('slide change');    
            // console.log(swiper.activeIndex);           
            this.$store.commit('menu/setSwiperIndexHome',swiper.activeIndex);
            document.querySelector('.scrollToTop').classList.remove('showscrollToTop');       
        },       
    } 
}
</script>
<style lang="scss">
$min-width: 20%;
$secondarycolor: #ab47bc;
@mixin transform($value){
  -webkit-transform: ($value);
     -moz-transform: ($value);
      -ms-transform: ($value);
          transform: ($value);
}
@mixin transition($value){
  -webkit-transition: ($value);
     -moz-transition: ($value);
      -ms-transition: ($value);
          transition: ($value);
}
.nav{
    position: relative;
    ul{     
        height: 50px;   
        .swiper-pagination-bullet:first-child{
            width: 0;
        }
        .swiper-pagination-bullet{        
            font-size:14px;
            font-weight: 700;
            font-family: naumgothic;
            line-height: 50px;
            border-radius: 0;
            width:20%;
            height:4px;
        }
        .swiper-pagination-bullet-active{
            background:#ab47bc;
        }
    }
    
    #marker{
        height: 4px;
        background: $secondarycolor !important;
        position: absolute;
        bottom: 0;
        width: $min-width;
        z-index: 2;
        @include transition(all 0.35s);
    }
    
    @for $i from 1 through 6{
        #main li:nth-child(#{$i}){            
            &.swiper-pagination-bullet-active ~ #marker{
            @include transform(translate(#{(-2+$i)*$min-width*5},0));
            }

        }
    }
    
}

</style>

<style lang="scss" scoped>
.home{    
   
    .nav{
        background: -webkit-linear-gradient(to right, #3d008d, #720685);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #3d008d, #720685); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        height:50px;       
        color:#fff;   
        width: 100%;       
        .swiper-pagination{
            margin:0;
            width:100%;
             
        }
       
       
    }
    .nav::-webkit-scrollbar-track {
        border: none;
        padding:  0;
        background-color: none;
    }
    .nav::-webkit-scrollbar {
        width: 0;
        border: none;
    }
    .nav::-webkit-scrollbar-thumb {
        border: none;
        
    }
    .swiper-slide{
        height:calc(100vh - 100px);
        width:100%;    
        font-size: 30px;
        text-align: center;
        .slide_image{
            width:100%;
            height:100%;
            background-size: cover;
            display:flex;
            flex-direction:column;
            justify-content: flex-end;
            cursor: pointer;
            .contArea{
                background:#000;
                opacity:.7;
                font-size:20px;  
                font-weight:bold;
                padding:10px;    
                height:80px;
                .title{
                    a{color:#fff;font-weight:bold}
                }
            }
        }
    

    }
   
}

</style>